/**
 * Denied Info Tab — Denied Reason email template configuration.
 * Internal Only (isLock) per item; master–detail layout via EmailCheckboxTemplateForm.
 */

import { EmailCheckboxTemplateForm } from '../EmailCheckboxTemplateForm'
import { saveDeniedInfoTemplate } from '../../services/underwritingConfigService'
import type { DeniedInfoTabProps } from '../../types'

export function DeniedInfoTab({ template, isLoading, onSuccess, onError }: DeniedInfoTabProps) {
  return (
    <EmailCheckboxTemplateForm
      template={template}
      isLoading={isLoading}
      variant="deniedAngular"
      onSave={async (data) => {
        await saveDeniedInfoTemplate(data)
      }}
      onSuccess={onSuccess}
      onError={onError}
      sendTemplateEditAnalytics
    />
  )
}
